import React from 'react'
import { ParallaxProvider } from 'react-scroll-parallax'

import theme from '../styles/theme'
import { media } from '../styles/tools'
import { isBrowser } from '../utils'

import { NavbarThemeProvider } from '../contexts/NavbarTheme'
import { BusinessTypeProvider } from '../contexts/BusinessType'
import {
  TileTransitionProvider,
  TileTransitionObject,
} from '../contexts/TileTransition'

import Head from '../components/Head'

import Link from '../components/Link'
import QuoteOverlay from '../components/QuoteOverlay'
import BarColumn from '../components/BarColumn'
import Space from '../components/Space'
import Logo from '../components/Logo'
import Play from '../components/Play'
import SocialLinks from '../components/SocialLinks'
import Navbar from '../components/Navbar'
import ScrollToIntended from '../components/ScrollToIntended'

import click18 from '../assets/sounds/click_18.wav'

if (isBrowser) {
  let latestTitle
  let restoreTitleTimeout

  window.addEventListener('blur', () => {
    latestTitle = document.title
    document.title = 'Come back, we miss you!'
    restoreTitleTimeout = setTimeout(() => (document.title = latestTitle), 5000)
  })

  window.addEventListener('focus', () => {
    if (latestTitle) document.title = latestTitle
    clearTimeout(restoreTitleTimeout)
  })
}

const Layout = ({ children }) => (
  <ParallaxProvider>
    <TileTransitionProvider>
      <BusinessTypeProvider>
        <NavbarThemeProvider>
          <div css={{ display: 'flex', minHeight: '100vh' }}>
            <Head />
            <ScrollToIntended delay={0.7} />
            <QuoteOverlay />
            <TileTransitionObject />

            <BarColumn
              as="aside"
              css={{
                display: 'flex',
                [media.max.laptop]: { display: 'none' },
                flexDirection: 'column',
                alignItems: 'center',
                height: '100vh',
                position: 'sticky',
                top: 0,
                zIndex: theme.zIndex.indexOf('bar'),
                backgroundColor: theme.colors.grey_1100,
                willChange: 'transform',
                overflow: 'hidden',
              }}
            >
              <Space y={theme.space.lg} />
              <Link to="/" css={{ width: '65%' }}>
                <Play sounds={{ playOnClick: click18 }}>
                  {({ playOnClick }) => <Logo onClick={playOnClick} />}
                </Play>
              </Link>
              <SocialLinks css={{ marginTop: 'auto' }} />
              <Space y={theme.space.lg} />
            </BarColumn>

            <div css={{ flexGrow: 1 }}>
              <div
                css={{
                  position: 'fixed',
                  top: 0,
                  right: 0,
                  left: theme.barWidth.mobile,
                  zIndex: theme.zIndex.indexOf('mobileNavbar'),
                  [media.laptop]: {
                    left: theme.barWidth.laptop,
                    zIndex: theme.zIndex.indexOf('desktopNavbar'),
                  },
                  willChange: 'transform',
                }}
              >
                <Navbar />
              </div>
              {children}
            </div>
          </div>
        </NavbarThemeProvider>
      </BusinessTypeProvider>
    </TileTransitionProvider>
  </ParallaxProvider>
)

export default Layout
